import { useResearchItems } from "@/hooks/useResearch";
import { Card, CardContent } from "@/components/ui/card";
import { Badge } from "@/components/ui/badge";
import { Link } from "react-router-dom";
import { format } from "date-fns";

export default function ResearchManager() {
  const { data: items } = useResearchItems({});
  const byStatus = (items ?? []).reduce<Record<string, typeof items>>((acc, i) => {
    (acc[i.status] = acc[i.status] || ([] as any)).push(i);
    return acc;
  }, {} as any);

  const cols: { key: string; label: string }[] = [
    { key: "draft", label: "Drafts" },
    { key: "in_review", label: "In Review" },
    { key: "approved", label: "Approved" },
    { key: "published", label: "Published" },
  ];

  return (
    <div>
      <div className="grid md:grid-cols-4 gap-4">
        {cols.map((c) => (
          <Card key={c.key}>
            <CardContent className="p-3 space-y-2">
              <div className="flex items-center justify-between">
                <h3 className="font-semibold text-sm">{c.label}</h3>
                <Badge variant="outline">{byStatus[c.key]?.length ?? 0}</Badge>
              </div>
              <div className="space-y-2 max-h-[60vh] overflow-y-auto">
                {(byStatus[c.key] ?? []).map((i) => (
                  <Link
                    key={i.id}
                    to={`/partner/research/${i.id}`}
                    className="block p-2 rounded border hover:border-primary"
                  >
                    <div className="text-sm font-medium line-clamp-2">{i.title}</div>
                    <div className="text-[10px] text-muted-foreground mt-1">
                      {format(new Date(i.updated_at), "dd/MM/yyyy")}
                      {i.primary_axis && ` · ${i.primary_axis}`}
                    </div>
                  </Link>
                ))}
                {(!byStatus[c.key] || byStatus[c.key]?.length === 0) && (
                  <p className="text-xs text-muted-foreground">No entries</p>
                )}
              </div>
            </CardContent>
          </Card>
        ))}
      </div>
    </div>
  );
}
